import React, { useState, useEffect } from "react";
import TypingEffectTextWrapper from "./TypingEffectTextWrapper";

interface TypingEffectPlaceholderProps {
	sentences: string[];
	inputValue: string;
	speed?: number;
	className?: string;
	style?: React.CSSProperties;
}

const TypingEffectPlaceholder: React.FC<TypingEffectPlaceholderProps> = React.memo(({
	sentences,
	inputValue,
	speed = 45,
	className = "",
	style = {},
}) => {
	const [currentIdx, setCurrentIdx] = useState(0);
	const [show, setShow] = useState(true);
	const [typingKey, setTypingKey] = useState(0);

	useEffect(() => {
		setShow(inputValue.length === 0);
	}, [inputValue]);

	useEffect(() => {
		if (!show) return;
		// When sentence changes, restart animation
		setTypingKey((k) => k + 1);
	}, [currentIdx, show]);

	useEffect(() => {
		if (!show) return;
		// Wait for animation to finish, then go to next sentence
		const sentence = sentences[currentIdx];
		const duration = sentence.length * speed + 800; // 800ms pause after typing
		const timer = setTimeout(() => {
			setCurrentIdx((idx) => (idx + 1) % sentences.length);
		}, duration);
		return () => clearTimeout(timer);
	}, [currentIdx, sentences, speed, show]);

	if (!show) return null;

	return (
		<div
			style={{
				position: "absolute",
				left: 16,
				top: "50%",
				transform: "translateY(-50%)",
				pointerEvents: "none",
				color: "#888",
				fontSize: 17,
				fontWeight: 500,
				fontFamily: 'Inter, Arial, sans-serif',
				whiteSpace: "nowrap",
				opacity: 0.7,
				...style,
			}}
			className={className}
		>
			{/* Use key to force TypingEffectTextWrapper to restart animation */}
			<TypingEffectTextWrapper
				key={typingKey}
				text={sentences[currentIdx]}
				speed={speed}
				reserveFullWidth={false}
                alwaysStart={true}
				style={{ color: "#888", fontSize: 17, fontWeight: 500, fontFamily: 'Inter, Arial, sans-serif', whiteSpace: "nowrap" }}
			/>
		</div>
	);
});

export default TypingEffectPlaceholder;